import {
    AUTHENTICATION_PATHS,
    ERROR_PATHS,
    ROOT_PATHS,
    DETAIL_PATHS, SUCCESS_PATHS, CHECKOUT_PATHS, CART_PATHS
} from '~core/constants/paths.constants';
import type { Route } from '@angular/router';
import { ERROR_URLS } from '~core/constants/urls.constants';


export const appRoutes: Route[] = [
    {
        path: ROOT_PATHS.home,
        loadChildren: async () =>
            import('./features/home/home.routes').then((module) => module.HOME_ROUTES),
        data: { preload: true },
        title: 'home',
    },
    {
        path: AUTHENTICATION_PATHS.base,
        loadChildren: async () =>
            import('./features/authentication/authentication.routes').then(
                (module) => module.AUTHENTICATION_ROUTES,
            ),
    },
    {
        path: ERROR_PATHS.base,
        loadChildren: async () =>
            import('./features/error/error.routes').then((module) => module.ERROR_ROUTES),
    },
    {
        path: DETAIL_PATHS.base,
        loadChildren: async () =>
            import('./features/detail/detail.routes').then((module) => module.DETAIL_ROUTES),
        title: 'detail'
    },
    {
    path: SUCCESS_PATHS.base,
        loadChildren: async () =>
            import('./features/success/success.routes').then((module) => module.SUCCESS_ROUTES),
        title: 'success'
    },
    {
        path: CHECKOUT_PATHS.base,
        loadChildren: async () =>
            import('./features/checkout/checkout.routes').then((module) => module.CHECKOUT_ROUTES),
        title: 'pagamento_ordine'
    },
    {
        path: CART_PATHS.base,
        loadChildren: async () =>
    import('./features/cart/cart.routes').then((module) => module.CART_ROUTES),
        title: 'cart'
    },
    { path: '**', redirectTo: ERROR_PATHS.base },
];